

  var swiper = new Swiper(".testimonialsSlider", {
    spaceBetween: 10,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    // pagination: {
    //   el: ".swiper-pagination",
    //   clickable: true,
    // },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      "320": {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      "576": {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      "991": {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      "1199": {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      
    },
  });
  var swiper = new Swiper(".showResultSlider", {
    spaceBetween: 10,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      "320": {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      "576": {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      "991": {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      "1199": {
        slidesPerView: 4,
        spaceBetween: 30,
      },
      
    },
  });

document.getElementById('shopNowLink').addEventListener('click', function(event) {
            event.preventDefault();
            document.getElementById('cst-pro-sect').scrollIntoView({ behavior: 'smooth' });
        });

document.getElementById('tap-transform').addEventListener('click', function(event) {
            event.preventDefault();
            document.getElementById('cst-pro-sect').scrollIntoView({ behavior: 'smooth' });
        });